export const AllowedFileTypes = ['pdf', 'png', 'jpg', 'jpeg'];